export default "__VITE_ASSET__BGSU9A6r__"